export const removeGapAndConvertToLowerCase = (text) => {
  return text.replace(/-| /g, "_").toLowerCase();
};
